var _jsxFileName = "/codebuild/output/src1744610141/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/GenderPicker/index.tsx";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { BottomSheet, Picker } from '@adc/parallax-component-library';
import { Genders } from 'Constants';
import i18n from 'Utilities/i18n';
const mapStateToProps = ({
  config
}) => {
  return {
    supportedCountries: config.supportedCountries
  };
};
const PICKER_WHEEL_WIDTH = 80;
const connector = connect(mapStateToProps);
const GenderPicker = ({
  onDone,
  selectedGender,
  isOpen
}) => {
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const ref = useRef(null);
  const pickerRef = useRef(null);
  const genders = useMemo(() => [{
    key: Genders.FEMALE,
    label: i18n.t('Global.microcopy.genderOptions.female')
  }, {
    key: Genders.MALE,
    label: i18n.t('Global.microcopy.genderOptions.male')
  }, {
    key: Genders.UNDETERMINED,
    label: i18n.t('Global.microcopy.genderOptions.other')
  }], []);
  const gendersLabel = useMemo(() => genders.map(gender => gender.label), [genders]);
  useEffect(() => {
    if (isOpen) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.present();
    } else {
      var _ref$current2;
      (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.close();
    }
  }, [isOpen]);
  useEffect(() => {
    if (selectedGender && isOpen) {
      const index = genders.findIndex(gender => gender.key === selectedGender);

      // Ensure the picker is rendered before scrolling
      setTimeout(() => {
        if (pickerRef.current) {
          pickerRef.current.scrollToIndex(index);
        }
      }, 100);
    }
  }, [selectedGender, genders, isOpen]);
  return /*#__PURE__*/React.createElement(BottomSheet, {
    ref: ref,
    enableDynamicSizing: true,
    testID: "GenderPicker",
    topNavigationProps: {
      lightTitle: true,
      title: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.label'),
      buttonEnd: {
        element: i18n.t('Global.microcopy.common.done'),
        onPress: () => {
          const gender = genders[selectedItemIndex].key;
          onDone(gender);
        }
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Picker, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Picker.Wheel, {
    width: PICKER_WHEEL_WIDTH,
    ref: pickerRef,
    items: gendersLabel,
    ariaLabel: i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.gender.placeholder'),
    onSelect: selectedIndex => {
      setSelectedItemIndex(selectedIndex);
    },
    initialSelectedIndex: selectedItemIndex,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 11
    }
  }))));
};
const ConnectedGenderPicker = connector(GenderPicker);
export { ConnectedGenderPicker as GenderPicker };